


































































import Component from "vue-class-component";

import { RingLoader } from "vue-spinners-css";

import { MyPatientsListItem, VaeSurveillanceType } from "@/models";
import _auth from "@/utils/auth";
import { EventBus, EventNames } from "@/utils/eventBus";
import _gateway from "@/utils/gateway";
import { sortByFullName } from "@/utils/names";
import { BaseRootPageComponent } from "./BaseRootPageComponent";
import MyPatientsRow from "./MyPatientsRow.vue";
import { updateGTMGlobalVariables } from "@/utils/gtm";

export const SortByStorageKey = "Messenger_MyPatients_SortBy";
export type SortOption = "messages" | "vae";

@Component({
  components: { MyPatientsRow, RingLoader }
})
export default class MyPatients extends BaseRootPageComponent {
  // Use a class property for dependencies so unit tests can override them
  auth = _auth;
  gateway = _gateway;

  // Make the storage a public property so that it can be overwritten in the unit tests
  storage: Storage = localStorage;

  isDestroyed = false;

  loading = true;
  sortBy: SortOption = "messages";
  patients: MyPatientsListItem[] = [];
  timeOfData?: string;
  get isSortingOnVae() {
    return this.sortBy === "vae";
  }

  get hasNoPatients() {
    return !this.patients || this.patients.length === 0;
  }

  async created() {
    // updateGTMGlobalVariables(this);

    // Need to call this here instead of the field initializer so that this.storage can be hooked up
    this.sortBy = this.loadSortBy();

    try {
      this.setTitle("My Patients");
      await this.loadPatients();

      // Subscribe after loading patients, so that we don't refresh while loading the patients
      this.subscribeToEvents();
    } finally {
      this.loading = false;
    }
  }

  loadSortBy(): SortOption {
    const sortBy = this.storage.getItem(SortByStorageKey);

    if (sortBy === "vae") return "vae";
    else return "messages";
  }

  setSortBy(sortBy: SortOption) {
    this.sortBy = sortBy;
    this.storage.setItem(SortByStorageKey, this.sortBy);
    this.sortPatients();
  }

  subscribeToEvents() {
    // If the component has already been destroyed (e.g. the user navigated away while the initial data was being
    // loaded), don't register for the data refresh event otherwise, it will never be removed and will keep running
    // until the user reloads the webpage.
    if (this.isDestroyed) return;

    EventBus.$on(EventNames.DataRefresh, this.loadPatients);
  }

  beforeDestroy() {
    EventBus.$off(EventNames.DataRefresh, this.loadPatients);
    this.isDestroyed = true;
  }

  async loadPatients() {
    // If somehow the component was already destroyed, don't bother loading
    if (this.isDestroyed) return;

    const list = await this.gateway.getMyPatients();
    this.patients = list.patients;

    this.sortPatients();
    this.timeOfData = list.timeLastClientVentLoadUtc;
  }

  selectedPatient(patient: MyPatientsListItem): void {
    this.$router.push(`/patients/${patient.id}`);
  }

  goToSelectPatients() {
    this.$router.push("/select-patients");
  }

  sortByActiveNotificationCount(a: MyPatientsListItem, b: MyPatientsListItem) {
    if (a.activeNotificationCount > b.activeNotificationCount) return -1;
    else if (a.activeNotificationCount === b.activeNotificationCount) return sortByFullName(a, b);
    else return 1;
  }

  sortPatients() {
    if (this.sortBy == "vae") {
      this.patients = this.patients.sort((a, b) => {
        const av = a.vaeSurveillanceType ?? VaeSurveillanceType.None;
        const bv = b.vaeSurveillanceType ?? VaeSurveillanceType.None;

        // VAE Surveillance Type should be sorted in descending order where the most severe (highest) is first
        if (av > bv) return -1;
        else if (av === bv) return this.sortByActiveNotificationCount(a, b);
        else return 1;
      });
    } else {
      this.patients = this.patients.sort((a, b) => {
        return this.sortByActiveNotificationCount(a, b);
      });
    }
  }
}
